//
//
//
//
//

export default {
  name: 'group-transition',
  props: {
    name: {
      type: String,
      default: 'fade-in'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/el-group-transition.vue